<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { urlcode } from "@/config.js"
  export default {
    name: 'App',
    created(){
      localStorage.setItem("urlcode", urlcode);
    }
  }
</script>

<style>
label{
  font-weight: 700;
}
.el-dialog{
  padding-bottom: 20px;
}
body{
  background-color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue